import { IconCalendarOff } from '@tabler/icons-react-native';
import { LoanCard } from 'app/components/loan-card';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { localeAwareFormat } from 'app/lib/date';
import type { Loan } from 'app/types/loan';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';

export function DesktopDateLoans({
  date,
  loans,
  onLoanHoverIn,
  onLoanHoverOut,
  onLoanSelect,
}: {
  date: Date;
  loans: Loan[];
  onLoanHoverIn: (id: Loan['id']) => void;
  onLoanHoverOut: () => void;
  onLoanSelect: (id: Loan['id']) => void;
}) {
  const { t } = useTranslation('loans');

  return (
    <Column
      backgroundColor="surface.primary-neutral"
      borderRadius="radius.lg"
      gap="spacing.general.x4"
      padding="spacing.general.x4"
      testID="desktop-selected-date-loans"
    >
      <Column>
        <Text fontWeight="600" variant="bodyLarge">
          {localeAwareFormat(date, 'PPPP')}
        </Text>
        <Text color="text.secondary" fontSize={12}>
          {t('calendar.sheetSummary', { count: loans.length })}
        </Text>
      </Column>

      {loans.length ? (
        <Column gap="spacing.general.x3">
          {loans.map((loan) => (
            <LoanCard
              {...loan}
              key={loan.id}
              onCalendarBlur={onLoanHoverOut}
              onCalendarFocus={() => onLoanHoverIn(loan.id)}
              onCalendarHoverIn={() => onLoanHoverIn(loan.id)}
              onCalendarHoverOut={onLoanHoverOut}
              onCalendarSelect={() => onLoanSelect(loan.id)}
            />
          ))}
        </Column>
      ) : (
        <Row
          alignItems="center"
          backgroundColor="surface.default"
          borderRadius="radius.md"
          gap="spacing.general.x2"
          padding="spacing.general.x4"
        >
          <IconCalendarOff size={22} strokeWidth={ICON_STROKE_WIDTH} />
          <Text color="text.secondary">{t('calendar.noActivityOnDate')}</Text>
        </Row>
      )}
    </Column>
  );
}
